import { styled } from 'baseui'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'

export const StyledTitle = styled('h3', () => ({
  flexGrow: 1,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontFamily: 'Family/Body',
  fontWeight: 600,
  fontSize: '16px',
  letterSpacing: '-1.4%',
  color: '#343535',
  height: 'auto',
}))

export const CreateAddressButton = styled(SDButton, () => ({
  borderRadius: '.375rem',
  border: '1px solid  #015AA3',
  backgroundColor: 'rgba(255, 255, 255, 0.00)',
  fontSize: '0.875rem',
  color: '#015AA3',
  textAlign: 'center',
  marginTop: '.5rem',
  ':hover': {
    backgroundColor: '#015AA3',
    color: '#fff',
  },
}))

export const CreateAddressButtonContainer = styled('div', () => ({
  display: 'flex',
  height: '2rem',
  padding: '.25rem .75rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '.375rem',
  marginBottom: '1rem',
}))

export const MultipleInputsContainer = styled('div', () => ({
  display: 'flex',
  gap: '1rem',
}))
